;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="fcb2c106-52e8-41db-982d-b94f67f135eb",e._sentryDebugIdIdentifier="sentry-dbid-fcb2c106-52e8-41db-982d-b94f67f135eb")}catch(e){}}();import Cookies from './node_modules/.pnpm/js-cookie@2.2.1/node_modules/js-cookie/src/js.cookie.js';
import React__default, { useState, useEffect } from 'react';
import { isHeaderContent, fetchHeaderContent } from './api/headerServiceClient.js';
import AppContext, { defaultContext } from './context/AppContext.js';
import './_virtual/_sentry-release-injection-file.js';
import { useCart } from './hooks/useCart.js';
import { useLogin } from './hooks/useLogin.js';
import { initializeSentry, withSentryHub } from './utils/sentry.js';

function HeaderContextProvider({ children, content, configuration, }) {
    const [selectedShopLanguage, setSelectedShopLanguage] = useState(undefined);
    const [isLoggedIn, customerId, customerStatusLoaded] = useLogin();
    const [cart] = useCart();
    useEffect(() => {
        const selectedShopLanguageVal = Cookies.get('_zpLanguage');
        setSelectedShopLanguage(selectedShopLanguageVal);
    }, []);
    const [headerContentState, setHeaderContentState] = useState(() => (isHeaderContent(content) ? content : undefined));
    const [sentryInit, setSentryInit] = useState(false);
    useEffect(() => {
        if (sentryInit === false) {
            initializeSentry();
            setSentryInit(true);
            if (!content && configuration) {
                fetchHeaderContent(configuration)
                    .then((result) => {
                    if (isHeaderContent(result)) {
                        setHeaderContentState(result);
                    }
                })
                    .catch((e) => withSentryHub()?.captureException(e));
            }
        }
    }, [content, configuration, sentryInit]);
    const context = headerContentState && isHeaderContent(headerContentState)
        ? {
            ...headerContentState,
            categories: headerContentState.categories ?? [],
            translations: new Map(Object.entries(headerContentState.translations ?? {})),
            cart,
            isLoggedIn,
            selectedShopLanguage,
            customerId,
            customerStatusLoaded,
            isError: false,
            bundle: headerContentState.bundle,
            backendHeaderVersion: headerContentState.headerVersion,
        }
        : { ...defaultContext, isError: true };
    return (React__default.createElement(AppContext.Provider, { value: context }, children));
}

export { HeaderContextProvider as default };
//# sourceMappingURL=HeaderContextProvider.js.map
